import { NgModule } from '@angular/core';

import { LocalizedDatePipe } from './localized-date.pipe';

const PIPES = [
    LocalizedDatePipe
];

@NgModule({
    imports: [],
    declarations: [...PIPES],
    providers: [],
    exports: [...PIPES]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/pipes/pipes.module.ts